import * as layerNames from '../../services/layerName';
const LayerComponents = {
  [layerNames.WELCOME_AD]: () =>
    import(/* webpackChunkName: "Welcome" */ '../Welcome'),
  [layerNames.SHARED_RED_PACKET_LAYER]: () =>
    import(/* webpackChunkName: "Welcome" */ '../ShareRedpack'),
  [layerNames.ACTIVITY_REDPACKET]: () =>
    import(/* webpackChunkName: "Welcome" */ '../ActivityRedPacket'),
  [layerNames.MAP_LAYER]: () => import(/* webpackChunkName: "Map" */ '../Map'),
  [layerNames.CERTIFICATE_LAYER]: () =>
    import(/* webpackChunkName: "Map" */ '../Certificate'),
  [layerNames.DEALER_ACTIVITY_LAYER]: () =>
    import(
      /* webpackChunkName: "FrameLayer" */ '../FrameLayers/DealerActLayer'
    ),
  [layerNames.PROMOTION_LIST]: () =>
    import(/* webpackChunkName: "Map" */ '../PromotionList'),
  [layerNames.SPECPIC_LAYER]: () =>
    import(/* webpackChunkName: "SpecInfo" */ '../SpecPicList'),
  [layerNames.SPEC_DOT_LAYER]: () =>
    import(/* webpackChunkName: "SpecInfo" */ '../SpecPicList'),
  [layerNames.SPEC_PARAMETER_LAYER]: () =>
    import(/* webpackChunkName: "SpecInfo" */ '../SpecParameter'),
  [layerNames.SPEC_PARAMETER_LAYER_SPECLIST]: () =>
    import(/* webpackChunkName: "SpecInfo" */ '../SpecList'),
  [layerNames.SPECLIST_LAYER]: () =>
    import(/* webpackChunkName: "SpecInfo" */ '../SpecList'),
  [layerNames.PRICELIST_SPECLIST_LAYER]: () =>
    import(/* webpackChunkName: "SpecInfo" */ '../SpecList'),
  [layerNames.SERIES_LIST]: () =>
    import(/* webpackChunkName: "SpecInfo" */ '../SeriesList'),
  [layerNames.PRICELIST_SERIES_LIST]: () =>
    import(/* webpackChunkName: "SpecInfo" */ '../SeriesList'),
  [layerNames.PROTOCAL]: () =>
    import(/* webpackChunkName: "Order" */ '../Order/ProtocalNew'),
  [layerNames.IM_ENTRANCE]: () =>
    import(/* webpackChunkName: "Order" */ '../Order/IMEntrance'),
  [layerNames.ORDER]: () =>
    import(/* webpackChunkName: "Order" */ '../Order/OrderNew'),
  [layerNames.ORDER_SUCCESS]: () =>
      import(/* webpackChunkName: "Order" */ '../Order/OrderNewSuccess'),
  [layerNames.INQUOREPOLICY_BOTTOM]: () =>
          import(/* webpackChunkName: "Order" */ '../CustomConfirm/InquirePolicyBottom'),
  [layerNames.CODE_BOTTOM]: () =>
                  import(/* webpackChunkName: "Order" */ '../CustomConfirm/CodeBottom'),
  [layerNames.ICSAPP_SHARE_PANEL]: () =>
    import(/* webpackChunkName: "ICSAppSharePanel" */ '../share/ICSSharePanel'),
  [layerNames.SHARE_PANEL]: () =>
    import(/* webpackChunkName: "AppSharePanel" */ '../share/AppSharePanel'),
  [layerNames.SHARE_POST]: () =>
    import(/* webpackChunkName: "AppSharePanel" */ '../share/SharePost'),
  [layerNames.VIDEO_LIST]: () =>
    import(/* webpackChunkName: "Video" */ '../Video/VideoList'),
  [layerNames.VIDEO_PLAYER]: () =>
    import(/* webpackChunkName: "Video" */ '../Video/VideoPlayer'),
  [layerNames.TOAST]: () => import(/* webpackChunkName: "TOAST" */ '../Toast'),
  [layerNames.VR_REALTIME_MASK]: () =>
    import(/* webpackChunkName: "vr-show-component" */ '../VR/Mask'),
  [layerNames.CAR_3D_LAYER]: () =>
    import(/* webpackChunkName: "FrameLayer" */ '../FrameLayers/Car3dLayer'),
  [layerNames.CAR_INTERIOR_LAYER]: () =>
    import(/* webpackChunkName: "FrameLayer" */ '../FrameLayers/InteriorLayer'),
  [layerNames.CAR_REALTIME_INTERIOR_LAYER]: () =>
    import(
      /* webpackChunkName: "FrameLayer" */ '../FrameLayers/RealtimeInteriorLayer'
    ),
  [layerNames.CONFIRM]: () =>
    import(/* webpackChunkName: "CONFIRM" */ '../Confirm'),
  [layerNames.HOME_CONFIRM]: () =>
    import(/* webpackChunkName: "HOME_CONFIRM" */ '../Confirm'),
  [layerNames.OFFCALLMODAL]: () =>
    import(/* webpackChunkName: "CONFIRM"*/ '../VR/OffCallModal'),
  [layerNames.RED_PACKET_FORM_LAYER]: () =>
    import(/* webpackChunkName: "RedForm"*/ '../RedPop/RedForm'),
  [layerNames.RED_PACKET_SUCCESS_LAYER]: () =>
    import(/* webpackChunkName: "RedSuccess"*/ '../RedPop/RedSuccess'),
  [layerNames.RED_PACKET_SUCCESS_LAYER_NEW]: () =>
      import(/* webpackChunkName: "RedSuccess"*/ '../RedPop/RedSuccessNew'),
  [layerNames.RED_PACKET_FAILED_LAYER]: () =>
    import(/* webpackChunkName: "RedFailed"*/ '../RedPop/RedFailed'),
  [layerNames.RED_PACKET_RULE_LAYER]: () =>
    import(/* webpackChunkName: "RedRule"*/ '../RedPop/RedRule'),
  [layerNames.RED_PACKET_IMG_CODE_LAYER]: () =>
    import(/* webpackChunkName: "RedPacketLayer"*/ '../RedPop/RedImgValidCode'),
  [layerNames.USER_WE_CHAT_PHONE]: () =>
    import(/* webpackChunkName: "GetWXC"*/ '../VR/GetWXC.vue'),
  [layerNames.USER_WE_CHAT_PHONE_IMG_CODE_LAYER]: () =>
    import(/* webpackChunkName: "RedPacketLayer"*/ '../RedPop/RedImgValidCode'),

  [layerNames.USER_AUTH]: () =>
    import(/* webpackChunkName: "UserAuth"*/ '../UserAuth.vue'),

  [layerNames.SALE_WE_CHAT_PHONE]: () =>
    import(/* webpackChunkName: "GetWXC"*/ '../VR/GetWXB.vue'),
  [layerNames.TRANSPARENT_MASK]: () =>
    import(/* webpackChunkName: "vr-show-component" */ '../VR/Mask'),
  [layerNames.PRICE_LIST]: () =>
    import(/* webpackChunkName: "dlrQuotation" */ '../PriceList/dlrQuotation'),
};
export default LayerComponents;
